import React, {useState} from "react";
import PropTypes from "prop-types";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import AddIcon from '@mui/icons-material/Add';


const TopBarSelect = (props) => {
    const {
        options,
        onSelection,
        renderOption,
        label,
        selected=null,
        createOption=false,
        onCreate=f=>f,
        createLabel=""
    } = props;

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleOpen = (e) => {
        setMenuAnchorEl(e.currentTarget);
    }

    const handleSelect = (option) => {
        handleClose();
        onSelection(option);
    }

    const handleClose = () => {
        setMenuAnchorEl(null);
    }

    const handleCreate = () => {
        handleClose();
        onCreate();
    }

    return <>
        <Button
            id="top-bar-select-button"
            aria-controls={menuOpen ? 'top-bar-select-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={handleOpen}
            color="inherit"
            endIcon={<ArrowDropDownIcon/>}
            sx={{p:0}}
        >
            { selected !== null ? renderOption(selected) : label}
        </Button>

        <Menu
            id="top-bar-select-menu"
            anchorEl={menuAnchorEl}
            open={menuOpen}
            onClose={handleClose}
            MenuListProps={{'aria-labelledby': 'top-bar-select-button'}}>
            {
                options.length === 0 && <MenuItem disabled>Nessun opzione presente</MenuItem>
            }
            {
                options.map((o, i) => <MenuItem key={i} dense onClick={() => handleSelect(o)}>
                    {renderOption(o)}
                </MenuItem>)
            }
            {createOption &&  options.length > 0 && <Divider/>}
            {
                createOption && <MenuItem dense onClick={handleCreate}>
                    <ListItemIcon>
                        <AddIcon fontSize="small"/>
                    </ListItemIcon>
                    {createLabel}
                </MenuItem>
            }
        </Menu>
    </>
}


TopBarSelect.propTypes = {
    options: PropTypes.arrayOf(PropTypes.object).isRequired,  // array of options
    onSelection: PropTypes.func.isRequired, // function called when a selection is clicked (the selected option is passed as argument)
    renderOption: PropTypes.func.isRequired, // function used to render an option
    label: PropTypes.string.isRequired, // string to display when no option is selected
    createOption: PropTypes.bool, // flag to enable the show and enable the create button
    onCreate: PropTypes.func, // function called when the create button is clicked (no argument is passed)
    createLabel: PropTypes.string, // label of the create button
}

export default TopBarSelect;